import React, { useState, useEffect } from "react";
import { Card } from "flowbite-react";
import clsx from "clsx";

import ApiService from "../../../services/api.service";

import Helper from "../../../common/helper";
import Global from "../../../common/global";

// import ErrorComponent from '../error';
import ErrorComponent from "../../errors/error-box";

export default function AsiaPayClient({
  languages,
  member,
  pMethod,
  transactionId,
  locationData,
  goNextStep,
  bcState,
}) {
  const [clientSecret, setClientSecret] = useState("");
  const [stripePromiseObj, setStripePromise] = useState("");
  const [stripeOptionsObj, setStripeOptions] = useState("");

  const [iframeSource, setSrc] = useState();

  //var clientSecret = "";
  var stripeOptions = {};

  //const mainStripePromise = null;
  const [error, setError] = useState("");

  useEffect(() => {
    if (
      locationData.PaymentMethod.AsiaPay &&
      locationData.PaymentMethod.AsiaPay.Enabled
    ) {
      triggerAsiaPayClientPromise(
        transactionId,
        locationData.PaymentMethod.AsiaPay.PaymentSName,
        pMethod
      );
    }

    window.addEventListener(
      "message",
      function (event) {
        if (event.data.event_id == "ASIAPAY_SUCCESS_DATA") {
          let data = Helper.urlParametersToJson(event.data.data.orderRef);
          goNextStep(transactionId, null, "AsiaPay Client");
        } else if (event.data.event_id == "ASIAPAY_FAIL_DATA") {
          console.error("message :: ASIAPAY_FAIL_DATA :: event data", event);

          let data = Helper.urlParametersToJson(event.data.data.orderRef);
          document.getElementById("directPaymentClient").src =
            document.getElementById("directPaymentClient").src;
        }
      },
      false
    );
  }, []);

  async function initAsiaPayClient(
    transactionId,
    paymentSName,
    pMethod,
    browserInfo
  ) {
    let asiapayParams = {
      orderRef: transactionId,
      PaymentSName: paymentSName,
      payMethod: pMethod,
      threeDSCustomerBrwInfo_data: browserInfo,
    };
    let asiapayClientResult = await ApiService.asiaPayDirectClient(
      asiapayParams
    );

    if (asiapayClientResult.errorMessage) {
      setError(asiapayClientResult.errorMessage);
    }

    //let iframeParams = asiapayClientResult;
    asiapayClientResult.errorUrl = encodeURIComponent(
      asiapayClientResult.errorUrl
    );
    asiapayClientResult.failUrl = encodeURIComponent(
      asiapayClientResult.failUrl
    );
    asiapayClientResult.cancelUrl = encodeURIComponent(
      asiapayClientResult.cancelUrl
    );
    asiapayClientResult.successUrl = encodeURIComponent(
      asiapayClientResult.successUrl
    );
    asiapayClientResult.actionURL = encodeURIComponent(
      asiapayClientResult.actionURL
    );
    asiapayClientResult.directClient = true;
    asiapayClientResult.location = locationData.country
      ? locationData.country
      : null;

    let iframeUrlParams = Helper.jsonToUrlParameters(asiapayClientResult);

    //if its Diners, add here!
    if (
      locationData.PaymentMethod.AsiaPay.dinerBC &&
      bcState == locationData.PaymentMethod.AsiaPay.dinerBC[0]
    ) {
      setSrc(Global.IFRAME_URL() + "/diner.html" + iframeUrlParams);
    } else if (
      locationData.PaymentMethod.AsiaPay.visaBC &&
      bcState == locationData.PaymentMethod.AsiaPay.visaBC[0]
    ) {
      setSrc(Global.IFRAME_URL() + "/visa-urbox.html" + iframeUrlParams);
    } else if (
      locationData.PaymentMethod.AsiaPay.jcbBC &&
      bcState == locationData.PaymentMethod.AsiaPay.jcbBC[0]
    ) {
      setSrc(Global.IFRAME_URL() + "/jcb.html" + iframeUrlParams);
    } else {
      setSrc(Global.IFRAME_URL() + "/iframe.html" + iframeUrlParams);
    }
    //setSrc(Global.BASE_URL() + iframeUrlParams);
  }

  async function triggerAsiaPayClientPromise(transactionId, paymentSName) {
    var getCustomerBrowserIp = function (url) {
      return fetch(url).then((response) => response.json());
    };

    let customerBrowserInfoObject = {};

    let jsEnabled = false;
    if (typeof window !== "undefined") {
      jsEnabled = true;
    }

    customerBrowserInfoObject["customerBrowserColorDepth"] =
      window.screen.pixelDepth;
    customerBrowserInfoObject["customerBrowserJavascriptEnabled"] = jsEnabled;
    customerBrowserInfoObject["customerBrowserLanguage"] =
      navigator.languages[0];
    customerBrowserInfoObject["customerBrowserScreenHeight"] =
      window.screen.availHeight;
    customerBrowserInfoObject["customerBrowserUserAgent"] = navigator.userAgent;
    customerBrowserInfoObject["customerBrowserTZ"] =
      new Date().getTimezoneOffset();
    customerBrowserInfoObject["customerBrowserScreenWidth"] =
      window.screen.availWidth;
    customerBrowserInfoObject["customerBrowserJavaEnabled"] =
      navigator.javaEnabled();

    ApiService.getIpAddress().then((data) => {
      customerBrowserInfoObject["customerBrowserIP"] = data.customerIp;
      console.log(
        'customerBrowserInfoObject["customerBrowserIP"]',
        customerBrowserInfoObject["customerBrowserIP"]
      );
      initAsiaPayClient(
        transactionId,
        paymentSName,
        pMethod,
        customerBrowserInfoObject
      );
    });

    console.log("customerBrowserInfoObject", customerBrowserInfoObject);
    //return customerBrowserInfoObject;
  }

  if (error) {
    return (
      <div>
        <ErrorComponent
          errorMessage={`Error: ${error}`}
          languages={languages}
        />
      </div>
    );
  } else {
    return (
      <div>
        <iframe
          id="directPaymentClient"
          // scrolling="no"
          src={iframeSource}
          height="750"
          width="100%"
          frameborder="0"
        ></iframe>
      </div>
    );
  }
}
